module.exports = __webpack_public_path__ + "static/media/voice-memo-graph.48c3599f.png";